import { ReactNode } from "react";
import ExclamationIcon from "../../assets/icons/ExclamationIcon";
import { CustomModalProps } from "../../types";
import CustomModal from "./CustomModal";

type ConfirmModalProps<T> = {
  data?: T;
  confirmTitle?: string;
  questionText?: string;
  submitDisabled?: boolean;
  okLoading?: boolean;
  handleOk: (val?: T) => void;
  children?: ReactNode;
  alertClassName?: string;
  hideAlert?: boolean;
  closable?: boolean;
} & CustomModalProps;

export default function ConfirmModal<T>({
  data,
  confirmTitle = "Delete This.",
  questionText = "Are sure to delete this item?",
  okText = "Delete",
  okLoading,
  submitDisabled,
  alertClassName = "",
  disableCloseButton,
  okButtonProps,
  handleOk,
  handleClose,
  children,
  hideAlert,
  closable = false,
  ...rest
}: ConfirmModalProps<T>) {
  return (
    <CustomModal
      width={400}
      handleClose={handleClose}
      closable={closable}
      okText={okText}
      onOk={() => handleOk(data)}
      okButtonProps={{
        loading: okLoading,
        className: "!rounded",
        ...okButtonProps,
      }}
      cancelButtonProps={{
        className: "cancel-btn",
      }}
      {...rest}
    >
      {!hideAlert ? (
        <div className={`flex gap-4 ${alertClassName}`}>
          <ExclamationIcon />
          <div>
            <h4 className="text-body text-lg font-medium leading-normal relative -top-[2.5px]">
              {confirmTitle}
            </h4>
            <p className="text-body text-sm font-normal leading-normal mt-1">
              {questionText}
            </p>
          </div>
        </div>
      ) : null}

      {children}
    </CustomModal>
  );
}
